import React from "react";
import styles from "./waiting.module.css";

function Waiting() {
  return (
    <div className={styles.body}>
      <div className={styles.loading}>
        <span className={styles.loading__dot}></span>
        <span className={styles.loading__dot}></span>
        <span className={styles.loading__dot}></span>
      </div>
    </div>
  );
}

export default Waiting;
